import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { from } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { AHRService, AuthenticatedIdentity, AuthenticationService, Case, CaseFiles, CurrentUser, Option, ReviewerCase, ProgramReviewSettings } from '../../../domain';
import { ConsoleService } from '../../../widgets/console.service';
import { ReviewerService } from '../reviewer.service';
import { SUPERVISOR_REVIEW_LOOKBACK_YEARS } from 'app/shared/constants';

@Component({
  selector: 'reviewer-case-detail',
  templateUrl: './reviewer-case-detail.component.html',
  styleUrls: ['./reviewer-case-detail.component.scss']
})
export class ReviewerCaseDetailComponent implements OnInit {

	case: ReviewerCase = undefined;
	fullCase: Case = undefined;
	caseFiles = { }; //Record<number, CaseFiles> = undefined;
	firstCaseYear: number;
	currentUser: Option<CurrentUser> = Option.create<CurrentUser>();
	reviewerType: string = "";
	settings: ProgramReviewSettings[] = [];
	workflowTaskId: number | null = null;
	error: string | null = null;

	_token:any="";
	constructor(
		private route: ActivatedRoute,
		private svc: AHRService,
		private console: ConsoleService,
		private authSvc: AuthenticationService,
		private reviewerService: ReviewerService
	) { }

	completeForMostRecentRole() {
		return !this.case ? false : false;//TODO
	}

	ngOnInit() {
		
		this.authSvc.currentIdentity.subscribe(i => {
			this._token = i.map(i => i.token);
			i.match(
				() => {
					this.currentUser = Option.create<CurrentUser>();
				},
				(i: AuthenticatedIdentity) => {
					this.currentUser = Option.create<CurrentUser>(i.user);
				});
		});

		let $caseId = this.route.params.pipe(map((params: Params) => +params['caseId']));

		this.reviewerService.reviewer$.subscribe((type) => {
			this.reviewerType = type;
		});

		$caseId.pipe(mergeMap(caseId => from(this.svc.getCaseToBeReviewedByWorkflowCaseId(caseId))))
			.subscribe({
				next: _case => {
					this.case = _case.getValueOrThrow();
					if (this.case.caseHistory && this.case.caseHistory[0] && this.case.caseHistory[0].periodOfReviewEndingInYear) {
						this.firstCaseYear = this.case.caseHistory[0].periodOfReviewEndingInYear;
					  } else {
						this.firstCaseYear = this.case.id.periodOfReviewEndingInYear;
					  }

					this.console.log('reviewer-case-detail arguments:', this.case.id.workflowCaseId, _case);

					this.reviewerService.updateWorkflowCaseId(this.case.id.workflowCaseId)

					this.loadCaseFiles(this.case.id, this.case.userId);

					this.workflowTaskId = null;
					this.svc.getWorkflowTaskIdForReviewer(
						this.case.id.workflowCaseId
					).then(id => this.workflowTaskId = id);
				},
				error: err => {
					this.console.log('reviewer-case-detail error:', err);
					this.workflowTaskId = null;
					this.error = 'Unable to load case. It may not exist or you may not have access.';
				}
			});

		this.svc.getSettings().then(settings => {
			this.settings = settings;
		});
	}

	public reviewerCanSeeCaseHistory() {
		// AHR, Supervisors and AVP can see case history. A relationship-only
		// supervisor (no task, so empty yourSteps) is flagged on the case instead.
		return this.currentUser.value.roles.academicHumanResources || this.case.isSupervisorRelationship || this.case.yourSteps.some(step => step.id == "Supervisors" || step.id == "FinalReviewer");
	}

	public isSupervisor(){
		return this.case.isSupervisorRelationship || this.case.yourSteps.some(step => step.id == "Supervisors");
	}

	public isCaseViewableBySupervisor(caseYear: number){
		return this.isSupervisor() && caseYear >= (new Date().getFullYear() - SUPERVISOR_REVIEW_LOOKBACK_YEARS);
	}

	public isReadOnlyStep(){
		return this.case.yourSteps.some(step => step.readOnlyStep);
	}

	// The submit affordance should appear only while a writable step's window is open:
	// not Upcoming (gate not yet open) and not PastDue (window closed). Completed steps
	// still qualify so a submitted review can be revised while the window remains open.
	public hasOpenReviewTask(){
		return this.case.yourSteps.some(step =>
			!step.readOnlyStep && !step.pastDue &&
			(step.status === 'Active' || step.status === 'Complete'));
	}

	public loadCaseFilesIfNeeded(caseId, userId:number) {
		this.loadCaseFiles(caseId, userId);
	}

	public loadCaseFiles(caseId, userId:number) {
		this.svc.getCaseFiles(caseId, userId).subscribe(files => {

			this.caseFiles[caseId.periodOfReviewEndingInYear] = files as CaseFiles;

			// only show review files that a reviewer is allowed to see. See: AHRDashboardReadModel.canReadReviewFilesFromReviewStepIds for logic
			this.caseFiles[caseId.periodOfReviewEndingInYear].reviewerFiles = 
				this.caseFiles[caseId.periodOfReviewEndingInYear].reviewerFiles
				.filter(file => 
					file.committeeName == "" 
					|| this.caseFiles[caseId.periodOfReviewEndingInYear].canReadReviewFilesFromCommitteeNames.includes(file.committeeName)
					);
		});
	}

	public caseFilesExist(periodOfReviewYear) {
		return !!this.caseFiles && this.caseFiles[periodOfReviewYear] != undefined;
	}

	public caseHistoryIsFirst(caseYear: number){
		if(caseYear == this.firstCaseYear) return true;
		return false;
	}

}